// Angular
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GestureConfig, MatButtonModule, MatCheckboxModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, MatSortModule, MatTableModule } from '@angular/material';
import { OverlayModule } from '@angular/cdk/overlay';
// Angular in memory
import { HttpClientInMemoryWebApiModule } from "angular-in-memory-web-api";
// Perfect Scroll bar
import {
	PERFECT_SCROLLBAR_CONFIG,
	PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
// SVG inline
import { InlineSVGModule } from "ng-inline-svg";
// Env
import { environment } from "../environments/environment";
// Hammer JS
import "hammerjs";
// NGX Permissions
import { NgxPermissionsModule } from "ngx-permissions";
// NGRX
import { StoreModule } from "@ngrx/store";
// import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from "@ngrx/router-store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
// State
import { metaReducers, reducers } from "./core/reducers";
// Copmponents
import { AppComponent } from "./app.component";
// Modules
import { AppRoutingModule } from "./app-routing.module";
import { CoreModule } from "./core/core.module";
import { ThemeModule } from "./views/theme/theme.module";
// Partials
import { PartialsModule } from "./views/partials/partials.module";
// Layout Services
import {
	DataTableService,
	// FakeApiService,
	KtDialogService,
	LayoutConfigService,
	LayoutRefService,
	MenuAsideService,
	MenuConfigService,
	MenuHorizontalService,
	PageConfigService,
	SplashScreenService,
	SubheaderService,
} from "./core/_base/layout";
// Auth
import { AuthModule } from "./views/pages/auth/auth.module";
// import { AuthService } from './core/auth';
// CRUD
import {
	HttpUtilsService,
	LayoutUtilsService,
	TypesUtilsService,
} from "./core/_base/crud";
// Config
import { LayoutConfig } from "./core/_config/layout.config";
// Highlight JS
import { HIGHLIGHT_OPTIONS, HighlightLanguage } from 'ngx-highlightjs';
import * as typescript from 'highlight.js/lib/languages/typescript';
import * as scss from 'highlight.js/lib/languages/scss';
import * as xml from 'highlight.js/lib/languages/xml';
import * as json from 'highlight.js/lib/languages/json';
import { SharedService } from './shared/sharedServices/shared.service';
// import * as Sentry from "@sentry/browser";
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { ProfileModule } from './views/pages/profile/profile.module';
import { MyHttpInterceptor } from './http.interceptor';
import { AsyncPipe, HashLocationStrategy, LocationStrategy } from '../../node_modules/@angular/common';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { AuthGuard } from './auth.guard';
import { GoogleAnalyticsService } from './shared/sharedServices/google-analytics.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
// import { BrowserTracing } from "@sentry/tracing";
import { Router } from "@angular/router";
import { ConfirmationDialogComponent } from './shared/shared-components/task-table/actiona-dialog.component';
// import { DesReportingComponent } from './views/pages/des-reporting/des-reporting.component';
// import { ToastrModule } from 'ngx-toastr';
// import {
//   ToastNoAnimation,
//   ToastNoAnimationModule
// } from 'ngx-toastr';
// tslint:disable-next-line:class-name
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	wheelSpeed: 0.5,
	swipeEasing: true,
	minScrollbarLength: 40,
	maxScrollbarLength: 300,
};

export function initializeLayoutConfig(appConfig: LayoutConfigService) {
	// initialize app by loading default demo layout config
	return () => {
		if (appConfig.getConfig() === null) {
			appConfig.loadConfigs(new LayoutConfig().configs);
		}
	};
}

export function hljsLanguages(): HighlightLanguage[] {
	return [
		{ name: "typescript", func: typescript },
		{ name: "scss", func: scss },
		{ name: "xml", func: xml },
		{ name: "json", func: json },
	];
}

// Sentry.init({
// 	dsn: "https://50ed52101bb940f781e4d1efa7bd3a10@o1289970.ingest.sentry.io/6509591",
// 	integrations: [
// 	  new BrowserTracing({
// 		tracingOrigins: ["localhost", "https://eservices.hec.gov.pk/"],
// 		routingInstrumentation: Sentry.routingInstrumentation,
// 	  }),
// 	],
  
// 	// Set tracesSampleRate to 1.0 to capture 100%
// 	// of transactions for performance monitoring.
// 	// We recommend adjusting this value in production
// 	tracesSampleRate: 1.0,
//   });

  
@NgModule({
	declarations: [AppComponent,ConfirmationDialogComponent],
	imports: [
		MatProgressSpinnerModule,
		BrowserModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
		MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
		ReactiveFormsModule,
		BrowserModule,
    MatDialogModule,
    MatButtonModule,
    BrowserAnimationsModule,
		MatDialogModule,
    MatButtonModule,
    BrowserAnimationsModule,
		BrowserAnimationsModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		// ToastrModule.forRoot(),
		// environment.isMockEnabled ? HttpClientInMemoryWebApiModule.forRoot(FakeApiService, {
		// 	passThruUnknownUrl: true,
		// 	dataEncapsulation: false
		// }) : [],
		NgxPermissionsModule.forRoot(),
		PartialsModule,
		CoreModule,
		OverlayModule,
		NgbModule,
		StoreModule.forRoot(reducers, { metaReducers }),
		// EffectsModule.forRoot([]),
		StoreRouterConnectingModule.forRoot({ stateKey: "router" }),
		StoreDevtoolsModule.instrument(),
		AuthModule.forRoot(),
		ProfileModule,
		TranslateModule.forRoot(),
		NgIdleKeepaliveModule.forRoot(),
		MatProgressSpinnerModule,
		InlineSVGModule.forRoot(),
		ThemeModule,
		InternationalPhoneNumberModule,
		DeviceDetectorModule,
		// AngularFireDatabaseModule,
		// AngularFireAuthModule,
		// AngularFireMessagingModule,
		// AngularFireModule.initializeApp(environment.firebase),
	],
	exports: [ConfirmationDialogComponent],
	providers: [
		// AuthService,
		AuthGuard,
		LayoutConfigService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		KtDialogService,
		SharedService,
		GoogleAnalyticsService,
		DataTableService,
		SplashScreenService,
		AsyncPipe,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
		},
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: GestureConfig,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MyHttpInterceptor,
			multi: true,
		},
		{
			// layout config initializer
			provide: APP_INITIALIZER,
			useFactory: initializeLayoutConfig,
			deps: [LayoutConfigService],
			multi: true,
		},
		{
			provide: HIGHLIGHT_OPTIONS,
			useValue: { languages: hljsLanguages },
		},
		// {
		// 	provide: ErrorHandler,
		// 	useValue: Sentry.createErrorHandler({
		// 	  showDialog: false,
		// 	}),
		//   },
		//   {
		// 	provide: Sentry.TraceService,
		// 	deps: [Router],
		//   },
		//   {
		// 	provide: APP_INITIALIZER,
		// 	useFactory: () => () => {},
		// 	deps: [Sentry.TraceService],
		// 	multi: true,
		//   },
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		// template services
		SubheaderService,
		MenuHorizontalService,
		MenuAsideService,
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		NgbActiveModal,
	],
	entryComponents:[ConfirmationDialogComponent],
	bootstrap: [AppComponent],
})
export class AppModule {}
